import React, { Component } from 'react'
import t from 'prop-types'
import styled from '@emotion/styled'
import { connect } from 'react-redux'
import { SubTitle } from '../../components/text'
import { FileInput } from '../../components/form'
import ProgressBar from '../../components/progressBar'
import Button from '../../components/button'
import 'react-responsive-carousel/lib/styles/carousel.min.css'
import { Carousel } from 'react-responsive-carousel'

const Container = styled.div`
  flex: 1;
  justify-content: flex-start;
  align-items: stretch;
`
const VideoContainer = styled.div`
  max-width: 50vw;
  max-height: 50vh;
  padding: 30px;
  margin: auto;
`

const ActionContainer = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-end;
`

class VideoEditor extends Component {
  static propTypes = {
    onChange: t.func.isRequired,
    uploadModel: t.func.isRequired,
    video: t.string.isRequired,
    closeModal: t.func.isRequired,
  }

  state = {
    // eslint-disable-next-line react/destructuring-assignment
    step: this.props.video && this.props.video.length ? 2 : 0,
    loaded: [],
    total: [],
    selected: 0,
    files: [],
    add: false,
    ...this.props,
  }

  onProgress = ({ loaded, total, i }) => {
    this.setState(state => ({
      total: [...state.total.slice(0, i), total, ...state.total.slice(i + 1)],
      loaded: [...state.loaded.slice(0, i), loaded, ...state.loaded.slice(i + 1)],
    }))
  }

  nextStep = () => {
    const { step } = this.state
    this.goToStep(step + 1)
  }

  goToStep = step => {
    this.setState({ step })
  }

  onFileChange = async ({ target: { files } }) => {
    const { video: currentVideos } = this.state
    const { uploadModel, onChange } = this.props
    this.goToStep(1)
    this.setState({
      total: Array.from(files).map(() => 1),
      loaded: Array.from(files).map(() => 0),
    })
    const video = await Promise.all(
      Array.from(files).map((file, i) => uploadModel({
        file,
        cb: ({ loaded, total }) => {
          this.onProgress({ loaded, total, i })
        },
      })),
    )
    this.setState({
      video: [...(currentVideos || []), ...video],
      add: false,
      files: [],
    })
    onChange({ video: [...(currentVideos || []), ...video] })
    this.goToStep(2)
  }

  onRemove = () => {
    const { updateVideo } = this.props
    const { video, selected } = this.state
    const newVideos = [...video.slice(0, selected), ...video.slice(selected + 1)]
    this.setState({
      video: newVideos,
      selected: selected >= newVideos.length ? selected - 1 : selected,
    })
    updateVideo(newVideos)
  }

  render() {
    const { files, step, video } = this.state
    if (step === 0) {
      return (
        <Container>
          <SubTitle primary>Video</SubTitle>
          <FileInput
            file={files}
            multiple
            onChange={this.onFileChange}
            accept="video/mp4,video/x-m4v,video/*"
          />
          {video && video.length ? (
            <Button onClick={this.setState({ step: 2 })}>Cancelar</Button>
          ) : null}
        </Container>
      )
    }
    if (step === 1) {
      const { total, loaded } = this.state
      const percentage = (100 * loaded.reduce((sum, n) => sum + n)) / total.reduce((sum, n) => sum + n)
      return (
        <Container>
          <SubTitle primary>Video</SubTitle>
          <ProgressBar label percentage={percentage} />
        </Container>
      )
    }
    if (step === 2) {
      const { video, selected, add } = this.state
      const { closeModal, showThumbs = false } = this.props
      return (
        <Container>
          <SubTitle primary>Video</SubTitle>
          <Carousel
            autoPlay={false}
            showThumbs={showThumbs}
            onChange={e => this.setState({ selected: e })}
            selectedItem={selected}
            useKeyboardArrows
          >
            {video.map(src => (
              <VideoContainer key={src}>
                <video src={src} controls style={{ width: '100%' }} />
              </VideoContainer>
            ))}
          </Carousel>
          {add && (
            <FileInput
              file={files}
              multiple
              onChange={this.onFileChange}
              accept="video/mp4,video/x-m4v,video/*"
            />
          )}
          <ActionContainer>
            <Button onClick={() => this.onRemove()}>Eliminar</Button>
            <Button primary contained onClick={() => this.setState({ add: true })}>
              Agregar
            </Button>
          </ActionContainer>
        </Container>
      )
    }
    return null
  }
}

const mapDispatchToProps = ({ anatomicMap: { uploadModel } }) => ({ uploadModel })

export default connect(
  null,
  mapDispatchToProps,
)(VideoEditor)
